import React from 'react';
import { reactionEmoji } from "../common/reactionEmoji";
import WebIM from './WebIM';

var rnReactionEmoji = function rnReactionEmoji(reaction) {
  if (reaction === undefined) {
    return [];
  }

  var rnReaction = [];

  if (reaction in reactionEmoji.map) {
    var v = reactionEmoji.map[reaction];
    rnReaction.push( /*#__PURE__*/React.createElement("img", {
      key: WebIM.conn.getUniqueId(),
      src: require("../common/reactions/" + v)["default"],
      style: {
        width: "20px",
        height: "20px",
        display: "inline-block"
      },
      alt: ""
    }));
  }

  return rnReaction;
};

export default rnReactionEmoji;